import MockBase from "./MockBase";
import { AuthzApi } from "../AuthzApi";

class MockAuthz extends MockBase implements AuthzApi {
  /**
   *
   */
  releaseLicenseConsumptionById(ids: string[]): Promise<any> {
    throw this.build404();
  }
}
export default MockAuthz;
